var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVgx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.202 1.03 23.606 1a1.175 1.175 0 0 0-1.08.712L15.79 16.464 9.25 1.712A1.175 1.175 0 0 0 8.173 1l-5.597.03a.588.588 0 0 0-.52.838l12.875 28.58a.935.935 0 0 0 1.703.006l13.09-28.586a.588.588 0 0 0-.52-.838z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgx);
export default __webpack_public_path__ + "static/media/VGX.ec8662004b229630fb84ff9f3f33be9e.svg";
export { ForwardRef as ReactComponent };